import { render, staticRenderFns } from "./fileraw.vue?vue&type=template&id=7820bdf6&scoped=true"
import script from "./fileraw.vue?vue&type=script&lang=js"
export * from "./fileraw.vue?vue&type=script&lang=js"
import style0 from "./fileraw.vue?vue&type=style&index=0&id=7820bdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820bdf6",
  null
  
)

export default component.exports